export default "__VITE_ASSET__sWvBmcF$Ke2NHFi9EikapQ__"